export default {
  styleOverrides: {
    root: {
      "& .MuiTableCell-head": {
        fontWeight: "bold"
      }
    }
  }
};
